'use client'

import { useEffect } from 'react'

export default function ScrollProgress() {
  useEffect(() => {
    const progressBar = document.createElement('div')
    const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--color-primary').trim() || '#4bb4ae'
    const primaryDark = getComputedStyle(document.documentElement).getPropertyValue('--color-primary-dark').trim() || '#3a8f8a'
    progressBar.style.cssText = `position: fixed; top: 0; left: 0; width: 0%; height: 3px; background: linear-gradient(90deg, ${primaryColor}, ${primaryDark}); z-index: 10001; transition: width 0.1s ease;`
    document.body.appendChild(progressBar)

    const handleScroll = () => {
      const scrollTop = document.documentElement.scrollTop
      const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight
      const scrollPercent = (scrollTop / scrollHeight) * 100
      progressBar.style.width = scrollPercent + '%'
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
      if (progressBar.parentNode) {
        progressBar.parentNode.removeChild(progressBar)
      }
    }
  }, [])

  return null
}
